import React from 'react'
import ReactModal from 'react-modal'
import AppLogo from '../../../assets/icons/page/rapture-logo.svg'
import Image from 'next/image'
import { BiLogoPlayStore } from 'react-icons/bi'
import { FaAppStoreIos } from 'react-icons/fa'

type Props = {
  isOpen: boolean
  onRequestClose: () => void
  isAndroid: boolean
}
const AppDownloadModal = ({ isOpen, onRequestClose, isAndroid }: Props) => {
  const customStyles = {
    content: {
      bottom: '0',
      left: '50%',
      transform: 'translateX(-50%)',
      width: '100%',
      maxWidth: '500px',
      height: '90px',
      padding: '0',
      borderRadius: '0',
      boxShadow: 'none',
      overflow: 'hidden',
      zIndex: 55000000,
      top: 'auto',
    },
    overlay: {
      backgroundColor: 'transparent',
    },
  }
  return (
    <ReactModal
      style={customStyles}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
    >
      <div className="w-full px-3 py-4 relative">
        <div className="w-full flex justify-end mb-1 absolute top-1 right-3">
          <button
            onClick={onRequestClose}
            className="text-gray-400 text-xl font-bold"
          >
            x
          </button>
        </div>
        <div className="w-full flex gap-4 justify-between mt-2 items-end">
          <div className="flex gap-4 items-center">
            <div className="w-15 h-auto">
              <Image src={AppLogo} alt="Rapture" />
            </div>
            <div>
              <p className="text-black font-bold">Install the Raptures App</p>
              <p>
                {isAndroid ? (
                  <div className="flex gap-1 items-center">
                    <BiLogoPlayStore className="text-gray-400" />
                    <p className="text-gray-400">Play Store</p>
                  </div>
                ) : (
                  <div className="flex gap-1 items-center">
                    <FaAppStoreIos className="text-gray-400" />
                    <p className="text-gray-400">App Store</p>
                  </div>
                )}
              </p>
            </div>
          </div>
          <a
            href={
              isAndroid
                ? 'https://play.google.com/store/apps/details?id=com.raptures.app'
                : 'https://apps.apple.com/us/app/raptures-comic/id1600027611'
            }
          >
            <button className="bg-[#4C1876] text-white font-semibold px-6 py-2 rounded-md">
              INSTALL
            </button>
          </a>
        </div>
      </div>
    </ReactModal>
  )
}

export default AppDownloadModal
